import { DeviceLabel } from './DeviceLabel';
import { DeviceType } from './DeviceType';
import { EntityBase } from './EntityBase';
import { DeviceOwner } from './DeviceOwner';

export interface Device extends EntityBase {
  deviceId: string;
  manufacturer: string;
  manufactureDateTime: Date;
  purchaseDateTime: Date;
  purchaseOrder: string;
  shipmentNbr: string;
  type: DeviceType;
  typeId: string;
  owner: DeviceOwner;
  model: number;
  series: string;
  labelTypeIds?: string[];
  labels?: DeviceLabel[];
}

export const getValueOrDefault = (value: any, defaultValue = 'N/A') => {
  return value ?? defaultValue;
};
